const ACTIVE_LINK_CLASS = 'w--current';
const ACTIVE_PANE_CLASS = 'w--tab-active';

const getContactTabs = (scope) => {
  const tabs = new Set();
  const selector = '#Contact-Us .tabs.w-tabs';

  if (scope?.matches?.(selector)) {
    tabs.add(scope);
  }

  if (typeof scope?.querySelectorAll === 'function') {
    scope.querySelectorAll(selector).forEach((tabsEl) => {
      tabs.add(tabsEl);
    });
  }

  return tabs;
};

const getTabsElements = (tabsEl) => {
  const links = Array.from(tabsEl.querySelectorAll(':scope > .w-tab-menu > .w-tab-link'));
  const panes = Array.from(tabsEl.querySelectorAll(':scope > .w-tab-content > .w-tab-pane'));

  return { links, panes };
};

const getTabName = (el) => el?.dataset?.wTab || '';

const syncContactTab = (tabsEl, tabName, shouldFocus = false) => {
  const { links, panes } = getTabsElements(tabsEl);
  const targetName = tabName || getTabName(links[0]);

  if (!targetName) {
    return;
  }

  tabsEl.dataset.current = targetName;

  links.forEach((link) => {
    const isActive = getTabName(link) === targetName;

    link.classList.toggle(ACTIVE_LINK_CLASS, isActive);
    link.setAttribute('role', 'tab');
    link.setAttribute('aria-selected', isActive ? 'true' : 'false');
    link.setAttribute('tabindex', isActive ? '0' : '-1');

    if (isActive && shouldFocus) {
      link.focus();
    }
  });

  panes.forEach((pane) => {
    const isActive = getTabName(pane) === targetName;

    pane.classList.toggle(ACTIVE_PANE_CLASS, isActive);
    pane.setAttribute('role', 'tabpanel');
    pane.hidden = !isActive;
  });
};

const moveFocus = (tabsEl, currentLink, direction) => {
  const { links } = getTabsElements(tabsEl);
  const currentIndex = links.indexOf(currentLink);

  if (currentIndex === -1 || !links.length) {
    return;
  }

  const nextIndex = (currentIndex + direction + links.length) % links.length;

  syncContactTab(tabsEl, getTabName(links[nextIndex]), true);
};

const initContactTabs = (scope = document) => {
  getContactTabs(scope).forEach((tabsEl) => {
    if (tabsEl.dataset.contactTabsInit === 'true') {
      return;
    }

    const { links, panes } = getTabsElements(tabsEl);

    if (!links.length || !panes.length) {
      return;
    }

    tabsEl.dataset.contactTabsInit = 'true';
    tabsEl.querySelector(':scope > .w-tab-menu')?.setAttribute('role', 'tablist');

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        syncContactTab(tabsEl, getTabName(link));
      });

      link.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          moveFocus(tabsEl, link, 1);
          return;
        }

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          moveFocus(tabsEl, link, -1);
          return;
        }

        if (event.key === 'Home') {
          event.preventDefault();
          syncContactTab(tabsEl, getTabName(links[0]), true);
          return;
        }

        if (event.key === 'End') {
          event.preventDefault();
          syncContactTab(tabsEl, getTabName(links[links.length - 1]), true);
          return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          syncContactTab(tabsEl, getTabName(link));
        }
      });
    });

    syncContactTab(tabsEl, tabsEl.dataset.current || getTabName(links.find((link) => link.classList.contains(ACTIVE_LINK_CLASS))) || getTabName(links[0]));
  });
};

initContactTabs();
window.initContactTabs = initContactTabs;
